__webpack_require__.p = "https://cityio-old.media.mit.edu/kharkiv/";